import * as React from 'react';
import { useNavigate } from 'react-router';
import type { PiletApi } from '@chess/platform-web';
import { registerCard } from '@chess/api-dashboard';
import { libraryLink, type FilterLink } from '@chess/api-insights/charts';
import { registerAggregator, useAggregate } from '@chess/api-model/react';
import '@chess/api-insights/charts.css';
import { EndingConversionCard, TITLE } from './EndingConversionCard.tsx';
import { EndingCasesAggregator } from './EndingCasesAggregator.ts';

// Ending card "Your losses": a pie of the period's endings not won, by how
// they went (slipped, missed, lost on time, lost; won endings and plain draws are not counted), second in the
// section after Ending results.
// On `home.section.ending` (order 5, second): the home screen's Ending section
// and the Ending screen render that one slot, so the card is written once.
// Links carry the last 30 days (`libraryLink`), so a slice's count is the
// filtered library's.
export function setup(app: PiletApi) {
  const getApi = <T,>(name: string) => app.getApi<T>(name);
  const aggregator = new EndingCasesAggregator();
  registerAggregator(getApi, aggregator);
  const Card: React.FC = () => {
    const { result, state } = useAggregate(getApi, aggregator);
    const navigate = useNavigate();
    const link = React.useMemo<FilterLink>(() => libraryLink((path) => navigate(path)), [navigate]);
    // Never hidden while the store loads: the card shows skeletons for its values.
    if (state?.status !== 'ready') return state?.status === 'failed' ? null : <EndingConversionCard loading />;
    return result ? <EndingConversionCard cases={result} link={link} /> : null;
  };
  // In the Ending screen's "More" section since 2026-10-08 (the stage's second top card before; Moves to practise took its place).
  registerCard(app, 'ending.more', Card, { order: 5, title: TITLE });
}
